import React from "react";
import FixedView from "../../FixedView";
class NewTask extends React.Component {
    constructor(props) {
        super(props)

        this.inputRef = React.createRef();
        this.newBoxRef = React.createRef();
        this.calendarPicker = React.createRef();
        this.calendarNode = React.createRef();
        this.linkRef = React.createRef();
        this.state = {
            Priority: "low",
            showCalendarPicker: false,
            newTask: false,
            link: "",
            options: [
                { icon: "/assets/icons/bookmark-black.svg", title: "" },
                { icon: "/assets/icons/paperclip-black.svg", title: "link" },
                { icon: "/assets/icons/alarm-black.svg" },
            ]
        }

    }
    onOptions(item) {
        if (item === "link")
            this.link.showView();
    }
    saveLink = () => {
        this.link.hideView();
        let link = this.linkRef.current.value;
        this.setState({ link: link })
    }
    addItem = () => {
        // this.props.addNewItem();
        this.props.addTask();
        this.setState({ newTask: false });
    }
    componentDidUpdate() {
        if (this.state.newTask) {
            document.addEventListener('keypress', this.onKeyPress)
        }
    }

    onKeyPress = (event) => {
        const randomColor = Math.floor(Math.random() * 16777215).toString(16);

        console.log(event.key, "enter")
        if (event.key === "Enter") {
            console.log("Enter Key Press");
            document.removeEventListener('keypress', this.onKeyPress);
            const newName = this.inputRef.current.value;

            this.props.addTask(newName, this.props.date, "rgb(109 213 250 / 37%)");
            this.setState({ newTask: false });

        }
    }
    render() {
        if (!this.state.newTask) {
            return (
                <div className="font-size-10" onClick={() => this.setState({ newTask: true })}>
                    <button>+ Add Task</button>

                </div>
            );
        }
        if (this.state.newTask) {
            return (
                <div className="nexItemBox" ref={this.newBoxRef} style={{ display: "flex", flexDirection: "column", border: "2px solid aliceblue", padding: "5px 2px" }}>
                    <div className="InputHolder " >
                        <div className="input d-flex">
                            <img src="/assets/icons/multiply-red.svg" width={15} onClick={() => this.setState({ newTask: false })} />
                            <input className="font-size-10" ref={this.inputRef} placeholder="Task name" type="text" style={{ border: "none", maxWidth: "90px", minWidth: "54px", background: "none" }}
                            />
                        </div>
                        <div style={{ paddingTop: "5px", display: "flex", justifyContent: "space-around" }} ref={e => this.linkCurrentNode = e}>
                            {this.state.options.map((prop, index) => {
                                return (
                                    <button className="" onClick={() => this.onOptions(prop.title)} >
                                        <img src={prop.icon} alt="bookmark" width={23} />
                                    </button>
                                )
                            })}

                        </div>
                    </div>
                    <FixedView ref={el => this.link = el} nodeRef={this.linkCurrentNode} showFocus={false} topOffset={3} xOffset={-130} zIndex={10} >
                        <div className='shadow-2 br-10 py-1 px-2 text-center flexcc ' style={{ backgroundColor: "#fff", width: "fit-content" }} >
                            <input placeholder="paste or write a link" style={{ border: 'none', fontSize: "10px" }} ref={this.linkRef} defaultValue={this.state.link} />
                            <button style={{ borderRadius: "5", background: "rgb(204 204 204 / 20%)", padding: "4px" }} onClick={() =>this.saveLink()}>Add</button>
                        </div>
                    </FixedView>
                </div>
            );
        }
    }
}

export default NewTask;
